/**
 * Centralized Wiki URLs for the application
 */
export const WIKI_URLS = {
    /** Main Wiki home page */
    HOME: 'https://wiki.syensqo.com/display/IC/Internal+ChatGPT+Home',
    /** Release notes page */
    RELEASE_NOTES: 'https://wiki.syensqo.com/pages/viewpage.action?pageId=899157532',
    /** Terms of Use document */
    TERMS_OF_USE:"https://docs.google.com/document/d/1wWxSRvixa_YlKgIqk1aMXLuoKUu1G9zrTwfbjG_aipo/edit?tab=t.0"
} as const;
